import { Route, Routes } from 'react-router-dom';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import { ProtectedRouter } from 'infrastructure/routing';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import PositionFillRequestsListPage from './List';
import { POSITION_FILL_REQUEST_READ, POSITION_FILL_REQUEST_SEARCH, POSITION_FILL_REQUESTS_PATH } from './constants';
import { usePositionFillRequestsRoute } from './routing';
import PositionFillRequestDetails from './show';

const PositionFillRequestsRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute } = usePositionFillRequestsRoute();

  return (
    <ProtectedRouter basePath={POSITION_FILL_REQUESTS_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={POSITION_FILL_REQUEST_SEARCH}>
              <PositionFillRequestsListPage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={POSITION_FILL_REQUEST_READ}>
              <PositionFillRequestDetails />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

PositionFillRequestsRouter.getRouterPath = () => `${POSITION_FILL_REQUESTS_PATH}/*`;

export default PositionFillRequestsRouter;
